// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { GenericSubscriptions } from '../../../../types/server/modules/generic/subscriptions';

export type * from '../../../../types/server/modules/generic/subscriptions';

export const createSubscriptions = ( requests: Requests ): GenericSubscriptions => ({
  ErroredStreams: ( params, onChange ) => {
          return requests.subscribe( `/errored-streams/:id?`, params, 'ErroredStreams', onChange );
          }
});
